import React, {useEffect, useState} from "react";
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { FilePond} from 'react-filepond';
import { useBaseUrlContext } from "../context/Base_url";
import { useAlertContext } from "../context/Alerts";

import {ThemeProvider, Container, Typography} from '@mui/material';
import {ThemeCustom} from '../styles/Theme';
import 'simplebar-react/dist/simplebar.min.css';
import 'filepond/dist/filepond.min.css';

import ButtonImgMain from "../components/button/Button_img_main";
import FooterBar from "../components/navbar/Footer_bar";

import FolderAdd from '../assets/folder-add.svg'
import File from '../assets/document-text.svg'
import Close from '../assets/close-circle.svg'
import docReview from '../assets/reveiwDoc.png'

const UploadCv = () => {

    const [files, setFiles] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const { baseUrl } = useBaseUrlContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const [jobId, setJobId] = useState('')

    useEffect(()=>{console.log('file',files)},[files])

    //get job id

    useEffect(()=>{
        const jobId = location.pathname.split('/').at(-1);
        console.log('jobId', jobId)
        setJobId(jobId)
    },[])


    //submit btn in footer

    const submitBtn = async () => {

        console.log('submitBtn')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
        }
        if(localStorage.getItem('token')){
            navigate(`/review/${jobId}`);
        }

        await Promise.all(
            files.map(async (file, index) => {
                await new Promise((resolve) => setTimeout(resolve, index * 2000)); // 2-second delay
                const formData = new FormData();
                formData.append('files', file.file);
                console.log('file',file)
                try {
                    await axios.post(`${baseUrl}/cv/upload/${jobId}`, formData, {headers:header});
                    console.log(`File ${index + 1} uploaded successfully`);
                } catch (error) {
                    console.error(`Error uploading file ${index + 1}:`, error);
                    failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
                }
            })
        );

        console.log('All files uploaded successfully!');

    }

    //cancel btn in footer

    const cancel = () => {
        console.log('cancel')
    }

    //remove all requirements

    const delAll = () => {
        setFiles([])        
    }

    //remove file

    const removeFile = (index) => {
        const fileRemove = [...files]
        fileRemove.splice(index, 1);
        setFiles(fileRemove)
    }

    return(
        <ThemeProvider theme={ThemeCustom}>
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div className="mb-7 flex justify-between items-center">
                    <Typography variant="textheader2" component={'div'}>Upload CVs</Typography>
                    <ButtonImgMain 
                        variant='primary' 
                        type='button' 
                        disabled={false} 
                        name='Go To Review'
                        class='capitalize'
                        img={docReview}
                        posision={'right'}
                        onClick={()=>navigate(`/review/${jobId}`)}
                    />
                </div>
                <div className='rounded-xl mb-5 bg-white p-5'>
                    <SimpleBar className="create-job-height rounded-xl p-0 m-0">
                        <div className='filepond-custom create-job-height h-[calc(100vh-20.25rem)]'>
                            {
                                files.length === 0 ? (
                                    <FilePond
                                        files={files}
                                        onupdatefiles={setFiles}
                                        allowMultiple={true}
                                        maxFiles={100}
                                        name="files"
                                        className={'fileUpload'}
                                        labelIdle={
                                            `<div class="w-full border border-dashed border-cultured bg-culturedLight p-4 rounded-md min-h-full flex flex-col justify-center items-center"><img src=${FolderAdd} alt="flie add" class="w-16"/><div class="text-primary text-base font-sans font-medium my-4 text-center">Drag your CV files here. or <span class="filepond--label-action font-semibold">Browse</span></div></div>`
                                        }
                                        credits={false}
                                    />
                                ):(
                                    <div className=" w-full border border-solid border-culturedLight p-4 rounded-xl flex min-h-full h-full ">
                                        <div className="w-full  border border-dashed border-culturedDark bg-culturedLight p-4 rounded-md min-h-full overflow-y-auto">
                                        {files.map((file, index)=>(
                                            <div key={index} className="mb-4 bg-white border border-solid border-primary rounded-xl p-4 w-full flex justify-between items-center">    
                                                <div className="flex items-center">
                                                    <img src={File} alt="flie add" className="w-6 mr-3"/>
                                                    <div className="text-primary break-words text-sm font-sans font-medium text-center">{file.file.name}</div>
                                                </div>
                                                <img src={Close} alt="close" className="w-6 cursor-pointer" onClick={()=>removeFile(index)}/>
                                            </div>   
                                            ))}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </SimpleBar>
                </div>
                <FooterBar
                    submitBtn={submitBtn}
                    cancel={cancel}
                    btnFill={'Upload'}
                    buttonRightDel={files.length > 1 ? 'Delete All':''}
                    delAll={delAll}
                    disabledSecondary={files.length < 1 ? true : false}
                />
            </Container>
        </ThemeProvider>
        
    )
}

export default UploadCv;